import { GetterTree } from "vuex";
import { IServiceAccountsState } from ".";
import { IRootState } from "@/store/types";
import { IServiceAccount } from "@/models/serviceaccount";

export const getters: GetterTree<IServiceAccountsState, IRootState> = {
    scopedSAList(state): IServiceAccount[] | null {
        return state.SAScopedList;
    },
    unscopedSAList(state): IServiceAccount[] | null {
        return state.SAUnscopedList;
    },
    selectedServiceAccount(state): IServiceAccount | null {
        return state.selectedServiceAccount;
    },
    isSelectedServiceAccount(state): boolean {
        return state.isSelectedServiceAccount;
    },
};
